import React from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { IToursMapItem, ITourPreviewQueryVariables, ITourPreviewQueryData, TourPreviewQuery } from '../../store';
import { withRouter, RouteComponentProps } from 'react-router';
import { useQuery } from 'react-apollo-hooks';
import { Loading } from '..';

interface IPreviewProps {
    onClose: () => void
    tour: IToursMapItem
}

export default withRouter(({ history, match, location, tour, onClose }: RouteComponentProps & IPreviewProps) => {
    const { language = 'en' } = match.params as { language: string}
    const handleClick = () => history.push(`/${language}/${tour.countrySlug}/${tour.regionSlug}/${tour.citySlug}/${tour.slug}`, { ...location.state, tourId: tour.id})

    const matches = useMediaQuery('(max-width:480px)');

    const { data, loading } = useQuery<any, ITourPreviewQueryVariables, any>(TourPreviewQuery, { 
        variables: {
            where: {
                language,
                id: tour.id
            }
        }
    });

    const tourPreview = data ? (data as ITourPreviewQueryData).tour : null;
    return matches ? (<div className="map-preview" onClick={handleClick}>
        {!tourPreview || loading ? <Loading />
        : <>
            <img className="tour-preview-img" src={tourPreview.image}/>
            <span className="tour-preview-title">{tourPreview.title}</span>
            <button className="tour-preview-close" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClose() }}>
                <img src="/images/icons/close-icon.png" alt="X" />
            </button>
        </>
        } 
        
    </div>) : null
})